import createReducer from 'utils/redux/createReducer'

const initialState = {
	repairmenSelect: false
}

export default createReducer(initialState, {
	OPEN_REPAIRMEN_SELECT: (currentState, action) => ({
		repairmenSelect: true
	})
  , CLOSE_REPAIRMEN_SELECT: (currentState, action) => ({
		repairmenSelect: false
  })
  , PROJECT_REPAIRMEN_OK: (currentState, action) => ({
		repairmenSelect: false
  })
})



// WEBPACK FOOTER //
// ./src/reducers/projectForm.js